import { useCallback, useMemo } from 'react';
import { debounce } from 'lodash-es';

import { useEntityStore } from '../store';
import { useMultiSelectStore } from '../store/multi-select.store';

export const useBlockHighlight = () => {
  const { setHighlightedBlock } = useEntityStore(({ setHighlightedBlock }) => ({
    setHighlightedBlock,
  }));

  const handleSectionClick = useCallback(
    (blockId: string) => {
      const { activePartId, selectedBlockIds } = useMultiSelectStore.getState();
      if (activePartId && selectedBlockIds.size > 0) {
        const { submission } = useEntityStore.getState();
        const sectionOfClickedBlock = submission?.sections.find((section) =>
          section.blocks.some((block) => block.id === blockId),
        );
        if (sectionOfClickedBlock && sectionOfClickedBlock.id !== activePartId) {
          return;
        }
      }

      return setHighlightedBlock(blockId, true);
    },
    [setHighlightedBlock],
  );

  // eslint-disable-next-line -- It's fine to use inlined debounce here
  const handleMouseLeave = useCallback(
    debounce(() => {
      return setHighlightedBlock(undefined);
    }, 100),
    [setHighlightedBlock],
  );

  // eslint-disable-next-line -- It's fine to use inlined debounce here
  const handleMouseEnter = useCallback(
    debounce((blockId: string) => {
      return setHighlightedBlock(blockId, false);
    }, 100),
    [setHighlightedBlock],
  );

  return useMemo(
    () => ({
      onClick: handleSectionClick,
      onMouseLeave: handleMouseLeave,
      onMouseEnter: handleMouseEnter,
    }),
    [handleSectionClick, handleMouseLeave, handleMouseEnter],
  );
};
